import { render, staticRenderFns } from "./we-service-org.vue?vue&type=template&id=75123a51&"
import script from "./we-service-org.vue?vue&type=script&lang=js&"
export * from "./we-service-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports